export default __webpack_public_path__ + "images/IC.ec4e510.png";